import { errorModalAtom } from "@/store/atoms/errorModalAtoms";
import { useAtom } from "jotai";
import { Modal } from "./Modal";
import ErrorState from "./ErrorState";

export const GlobalErrorModal = () => {
  const [errorModalState, setErrorModalState] = useAtom(errorModalAtom);

  const close = () =>
    setErrorModalState({
      isOpen: false,
      error: undefined,
      textButton: "Close",
    });

  return (
    <Modal isOpen={errorModalState.isOpen} onClose={close}>
      <ErrorState
        error={errorModalState.error}
        reset={close}
        textButton={errorModalState.textButton}
      />
    </Modal>
  );
};
